import { IDanhSachLopTinChiAddOrUpdateRequest } from "../../../model/request/dang-ky-ho/IDanhSachLopTinChiAddOrUpdateRequest";
import { ILopTinChiSelectDangKyBySinhVienRequest } from "../../../model/request/dang-ky-ho/ILopTinChiSelectDangKyBySinhVienRequest";
import { IStuHoSoSinhVienViewModel } from "../../../model/respone/category/IStuHoSoSinhVienViewModel";
import { IDangKySelectByHocSinhRespone } from "../../../model/respone/dang-ky/IDangKySelectByHocSinhRespone";
import { IDanhSachSinhVienTinChiViewModel } from "../../../model/respone/lop-tin-chi/IDanhSachSinhVienTinChiViewModel";
import { IDangKyHoSinhVienReducer } from "../../reducer-model/dang-ky-ho/IDangKyHoReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IDangKyHocSinhVienActionTyes<T> {
    id: string,
    data: T
}
export const eDangKyHoActionsObj = {
    ADD_NEW_TAB: {} as undefined | IStuHoSoSinhVienViewModel,
    REMOVE_TAB: "",
    UPDATE_TAB_DATA: {} as IDangKyHoSinhVienReducer,
    CHANGEG_SELECTED_TAB: "",
    CHANGE_REQUEST_BASE: {} as ILopTinChiSelectDangKyBySinhVienRequest,
    CHANGE_FILTER: {} as {
        hinh_thuc_dang_ky: number;
    },
    LOAD_LOPTINCHI_SINHVIEN_START: {} as IDangKyHocSinhVienActionTyes<ILopTinChiSelectDangKyBySinhVienRequest>,
    LOAD_LOPTINCHI_SINHVIEN_SUCCESS: {} as IDangKyHocSinhVienActionTyes<IDangKySelectByHocSinhRespone>,
    LOAD_LOPTINCHI_SINHVIEN_ERROR: {} as IDangKyHocSinhVienActionTyes<string>,

    LOAD_DANGKY_SINHVIEN_START: {} as IDangKyHocSinhVienActionTyes<ILopTinChiSelectDangKyBySinhVienRequest>,
    LOAD_DANGKY_SINHVIEN_SUCCESS: {} as IDangKyHocSinhVienActionTyes<IDanhSachSinhVienTinChiViewModel[]>,
    LOAD_DANGKY_SINHVIEN_ERROR: {} as IDangKyHocSinhVienActionTyes<string>,

    DANGKY_SINHVIEN_START: {} as IDangKyHocSinhVienActionTyes<IDanhSachLopTinChiAddOrUpdateRequest>,
    DANGKY_SINHVIEN_SUCCESS: {} as IDangKyHocSinhVienActionTyes<IDanhSachSinhVienTinChiViewModel>,
    DANGKY_SINHVIEN_ERROR: {} as IDangKyHocSinhVienActionTyes<string>,

    HUY_DANGKY_SINHVIEN_START: {} as IDangKyHocSinhVienActionTyes<number>,
    HUY_DANGKY_SINHVIEN_SUCCESS: {} as IDangKyHocSinhVienActionTyes<number>,
    HUY_DANGKY_SINHVIEN_ERROR: {} as IDangKyHocSinhVienActionTyes<string>,

    RUT_HOCPHAN_SINHVIEN_START: {} as IDangKyHocSinhVienActionTyes<number>,
    RUT_HOCPHAN_SINHVIEN_SUCCESS: {} as IDangKyHocSinhVienActionTyes<number>,
    RUT_HOCPHAN_SINHVIEN_ERROR: {} as IDangKyHocSinhVienActionTyes<string>,

    CAPNHAT_CHUYENNGANH2_START: {} as IDangKyHocSinhVienActionTyes<{ id: number; chuyen_nganh2: boolean }>,
    CAPNHAT_CHUYENNGANH2_SUCCESS: {} as IDangKyHocSinhVienActionTyes<{ id: number; chuyen_nganh2: boolean }>,
    CAPNHAT_CHUYENNGANH2_ERROR: {} as IDangKyHocSinhVienActionTyes<string>,

};

export const eDangKyHoActionIds = generateActionTypeIds(eDangKyHoActionsObj, "DANG_KY_HO");
export type IDangKyHoActionTypes = IGenericActionType<typeof eDangKyHoActionsObj, "DANG_KY_HO">;